import type { ApiResponse } from '../../../../config/api-types'
import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { CreateCollectionOrderRequest } from '../../domain/models/create-collection-order'
import type { ICreateCollectionOrder } from '../../domain/use-cases/i-create-collection-order'
import type { ICreateCollectionOrderClient } from '../data-sources/i-create-collection-order-client'

export class CreateCollectionOrderRepository implements ICreateCollectionOrder {
  constructor(private readonly dataSource: ICreateCollectionOrderClient) {}

  async create(param: CreateCollectionOrderRequest): Promise<ApiResponse> {
    const result = await this.dataSource.create(param)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result.message!)
    }

    return result.data
  }
}
